module.exports = __webpack_public_path__ + "img/pay.585c39e2.png";